import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function AwsCommunityDayVadodara({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.awsCommunityDayAhmedabad', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            return '';
        }
        return String(value);
    };
    
    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                    <div className={'left-block sm-width'}>
                                        {Array.isArray(contentData?.description) && contentData.description.map((content: string, index: number) => (
                                            <p key={index} dangerouslySetInnerHTML={{__html: String(content).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                        ))}
                                    </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Meet us at AWS Ahmedabad",
            description:"We are a proud booth sponsor at the upcoming AWS Ahmedabad community day event. RSVP here to catch up:",
            ogImage: "/images/events/aws-ahmedabad.png/",
            uri:"/events/aws-community-day-ahmedabad/",
            metaTitle:"Meet us at AWS Ahmedabad Community Day",
            metaDesc:"We are a proud booth sponsor at the upcoming AWS Ahmedabad community day event. RSVP here to catch up:",
            metaRobotsNoindex:"index",
            metaRobotsNofollow:"follow",
        },
    }
}
